import { render, staticRenderFns } from "./modalEditarLeecheros.vue?vue&type=template&id=115dd3b0&"
import script from "./modalEditarLeecheros.vue?vue&type=script&lang=js&"
export * from "./modalEditarLeecheros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports